import { BehaviorSubject } from "rxjs";
import { filter, map } from "rxjs/operators";
import { arrayToVector } from "../../utils/vector-utils";
import { FlakesTexture } from "../../utils/FlakesTexture";
import * as THREE from "three";

class TextureManager {
  constructor(world) {
    this.world = world;

    this.textureDefinitions = {};
    this.textureDefinitions$ = {};

    this.textures = {};
    this.textures$ = {};
  }

  getTextureDefinition(id) {
    return this.textureDefinitions[id];
  }

  updateTextureProperties(texture, definition) {
    for (const key in definition) {
      if (
        texture.hasOwnProperty(key) &&
        !["id", "type", "file", "preload"].includes(key)
      ) {
        // convert [x,y] & [x,y,z] to vectors
        texture[key] = arrayToVector(definition[key]);
      }
    }
    return texture;
  }

  setTextureDefinition(id, definition) {
    this.textureDefinitions[id] = definition;
    const textureDefinition$ = this.getTextureDefinition$(id);
    if (definition) {
      textureDefinition$.next(definition);

      textureDefinition$
        .pipe(filter((definition) => definition.preload))
        // BUG: This will probably case multible subs ...
        .subscribe({
          next: (definition) => {
            const type = definition.type || "Texture";

            // Texture
            if (type === "Texture") {
              this.world.assetManager
                .getAsset$(definition.file.url)
                .pipe(
                  filter((asset) => asset),
                  // Asign definition props
                  map((texture) =>
                    this.updateTextureProperties(texture, definition)
                  )
                )
                .subscribe((texture) => {
                  this.setTexture(id, texture);
                });
            }

            // FlakesTexture
            if (type === "FlakesTexture") {
              const texture = this.updateTextureProperties(
                new THREE.CanvasTexture(new FlakesTexture()),
                definition
              );
              this.setTexture(id, texture);
            }
          },
        });
    } else {
      delete this.textureDefinitions[id];
      this.completeTextureDefinition$(id);
    }
  }

  getTextureDefinition$(id) {
    if (!this.textureDefinitions$[id]) {
      this.textureDefinitions$[id] = new BehaviorSubject();
    }
    return this.textureDefinitions$[id];
  }

  completeTextureDefinition$(id) {
    if (!this.textureDefinitions$[id]) {
      this.textureDefinitions$[id].complete();
      delete this.textureDefinitions$[id];
    }
  }

  getTexture(id) {
    return this.textures[id];
  }

  setTexture(id, texture) {
    this.textures[id] = texture;
    const texture$ = this.getTexture$(id);
    if (texture) {
      texture$.next(texture);
    } else {
      delete this.textureDefinitions[id];
      this.completeTextureDefinition$(id);
    }
  }

  getTexture$(id) {
    if (!this.textures$[id]) {
      this.textures$[id] = new BehaviorSubject();
    }
    return this.textures$[id];
  }

  completeTexture$(id) {
    if (!this.textures$[id]) {
      this.textures$[id].complete();
      delete this.textures$[id];
    }
  }
}

export default TextureManager;
